import React from 'react';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import { ILine as Line } from '../../../global';
import { getLineTotal, formatNumber } from '../../../utils';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Mobile/MobileSubmitApp';

function calculateAppHighlights(lines: Array<Line>): number {
  let total = 0;
  lines?.forEach((line: Line) => {
    const lineTotal = getLineTotal(line);
    total += lineTotal;
  });
  return total;
}

function getHeader(lines: Array<Line>) {
  const total = calculateAppHighlights(lines);

  return (
    <span>
      Congrats! <br />
      You're pre-approved for ${formatNumber(total)}.
    </span>
  );
}

export default function MobileSubmitApp() {
  const { business } = useCompanyContext();
  const { products, lines } = useLinesContext();

  return (
    <>
      <Stepper
        fetchLines={true}
        hideContent={!(products && business && lines)}
        title={getHeader(lines)}
        headerWidth={600}
        contentWidth={600}
      >
        <PageLayout />
      </Stepper>
    </>
  );
}
